import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { Col } from '../../../../../../1stlog-ui/src/components/Bootstrap'
import useProvider from '../useProvider'

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-end;
`

const ImgWrapper = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const Img = styled.img`
  max-height: 100%;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 60px;
  display: block;
`

const ProviderLogo = (props) => {
  const {} = props

  const provider = useProvider()

  const logoUrl = lodash.get(provider, 'logoUrl')

  if (!logoUrl) {
    return null
  }

  return (
    <Col md={2}>
      <Wrapper>
        <ImgWrapper>
          <Img src={logoUrl} />
        </ImgWrapper>
      </Wrapper>
    </Col>
  )
}

export default ProviderLogo
